/**
 * Canonical URL builders for public course/module/exercise pages.
 * All public content uses the flat /courses/ prefix (matches sitemap).
 */

export const courseUrl = (courseSlug: string) =>
  `/courses/${courseSlug}`;

export const moduleUrl = (courseSlug: string, moduleSlug: string) =>
  `/courses/${courseSlug}/${moduleSlug}`;

export const exerciseUrl = (courseSlug: string, moduleSlug: string, exerciseSlug: string) =>
  `/courses/${courseSlug}/${moduleSlug}/${exerciseSlug}`;
